function FilterBarPro({ filters, onChange, firms }) {
  const renderFilterSection = (title, items, key) => (
    <div>
      <div className="text-[10px] uppercase text-yellow-500 mb-2 tracking-wider">{title}</div>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => (
          <button
            key={item}
            onClick={() => {
              const exists = filters[key].includes(item);
              const next = exists
                ? filters[key].filter((v) => v !== item)
                : [...filters[key], item];
              onChange({ ...filters, [key]: next });
            }}
            className={`border border-yellow-700 text-yellow-300 px-3 py-1 rounded-full text-xs transition ${
              filters[key].includes(item)
                ? 'bg-yellow-400 text-black border-yellow-400'
                : 'hover:bg-yellow-400 hover:text-black'
            }`}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="mb-10 space-y-8">
      <div>
        <input
          type="text"
          placeholder="Search firm..."
          value={filters.search}
          onChange={(e) => onChange({ ...filters, search: e.target.value })}
          className="w-full bg-gray-900 border border-yellow-700 px-4 py-3 text-yellow-100 rounded-md text-sm placeholder-yellow-700 focus:outline-none"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {renderFilterSection(
          'Platforms',
          Array.from(new Set(firms.flatMap((f) => f.features.platforms || []))),
          'platforms'
        )}

        {renderFilterSection(
          'Daily Drawdown',
          Array.from(new Set(firms.flatMap((f) => f.features.dailyDrawdown || []))),
          'drawdown'
        )}

        {renderFilterSection(
          'Max Funding',
          Array.from(new Set(firms.flatMap((f) => f.features.maxFunding || []))),
          'maxFunding'
        )}

        {renderFilterSection(
          'Evaluation Type',
          Array.from(new Set(firms.flatMap((f) => f.features.evaluationTypes || []).flat())),
          'evaluation'
        )}

        {renderFilterSection(
          'Payout Frequency',
          Array.from(new Set(firms.flatMap((f) => f.features.payout || []))),
          'payout'
        )}

        {renderFilterSection(
          'Profit Split',
          Array.from(new Set(firms.flatMap((f) => f.features.profitSplit || []))),
          'profitSplit'
        )}
      </div>
    </div>
  );
}

export default FilterBarPro;
